let Parallax = {
  init(el, displace, direction)  {
    this.animateItem(el, displace, direction);
  },
  setPosition() {
    if (window.pageYOffset !== undefined) {
      return window.pageYOffset;
    } else {
      return (document.documentElement || document.body.parentNode || document.body).scrollTop;
    }
  },
  animateItem(el, displace, direction) {
    // if (typeof window.orientation !== 'undefined') { return; }
    let scrollPosition = this.setPosition();

    if (direction === 'sideways') {
      el.style.backgroundPosition = ((800 + scrollPosition) / displace)+"px center";
    } else {
      let value = (scrollPosition / displace) + direction;
      el.style.transform = "translate3d(0px, "+value+"px, 0px)";
    }
  }
}

export default Parallax;



/** WEBPACK FOOTER **
 ** ./es6/global/parallax.js
 **/